import MollieConnectMandates from './MollieConnectMandates';

export default MollieConnectMandates;
